export const TEXT_ANNOTATION_TYPE = {
  mainOfferings: 'mainOfferings',
  emotions: 'emotions',
  features: 'features',
  pains: 'pains',
  benefits: 'benefits',
  ctas: 'ctas',
  campaignKeywords: 'campaignKeywords',
} as const;
export type TextAnnotationType = (typeof TEXT_ANNOTATION_TYPE)[keyof typeof TEXT_ANNOTATION_TYPE];

export const MAX_ANNOTATION_SELECTION_COUNT = 3;
